import { GoodsFamily, getGoodsFamilyForAggregatedCategory } from '@/common'

/**
 * Returns the intersection of required GoodsFamilies for the given CN codes.
 * Used for batch-update installation eligibility: an installation must support all
 * economic activities required by the selected goods.
 *
 * @param cnCodes – CN codes of the selected goods
 * @param getAggregatedCategoryForCnCode – returns the aggregated goods category for a CN code (e.g. from goods config/API). Return undefined if unknown.
 * @returns Intersection of GoodsFamilies; empty if any CN code has no mapping or if the intersection is empty.
 */
export function getRequiredGoodsFamiliesForCnCodes(
  cnCodes: string[],
  getAggregatedCategoryForCnCode: (cnCode: string) => string | undefined
): GoodsFamily[] {
  if (cnCodes.length === 0) {return []}

  const familiesPerCode = cnCodes.map(cnCode => {
    const agg = getAggregatedCategoryForCnCode(cnCode)
    if (agg == null) {return null}
    return getGoodsFamilyForAggregatedCategory(agg) ?? null
  })

  if (familiesPerCode.some(fam => fam == null)) {return []}

  const allFamilies = familiesPerCode.filter((fam): fam is GoodsFamily => fam != null)
  const unique = [...new Set(allFamilies)]
  if (unique.length === 1) {return unique}
  return []
}
